import React, { CSSProperties, useState } from 'react';
import SeoResource from '../../../services/resources/SeoResource';

interface Props {
  name?: string;
  imageUrl: string;
  thumbnailUrl?: string | null;
  className?: string;
}

/**
 * The large product picture in the item modal.
 *
 * The thumbnail is cut at 372×372, so stretched to the modal's width (~625px) it looks
 * pixelated. The full image is shown instead, with the thumbnail — usually already cached
 * from the menu list — painted underneath until it loads. The placeholder is dropped on
 * load, or it would show through a photo with transparent areas.
 *
 * Tracked per URL so that moving to another product brings the placeholder back.
 */
export default function ProductDetailImage({ name, imageUrl, thumbnailUrl, className }: Props): JSX.Element {
  const [loadedUrl, setLoadedUrl] = useState<string | null>(null);

  const placeholder: CSSProperties | undefined =
    thumbnailUrl && loadedUrl !== imageUrl
      ? {
          backgroundImage: `url(${JSON.stringify(thumbnailUrl)})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }
      : undefined;

  return (
    <img
      src={imageUrl}
      alt={SeoResource.toAltText(`${name} image`)}
      className={className}
      style={placeholder}
      onLoad={() => setLoadedUrl(imageUrl)}
    />
  );
}
